module.exports = __webpack_public_path__ + "static/media/background.4eea4f85.png";